import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import PropTypes from "prop-types";

import { cardBasicType } from "types";

import styles from "./ClipboardItem.module.scss";

const ClipboardItem = ({ card, legal, onAdd, onPromote, onRemove, onShow, type }) => (
  <div className={styles.wrapper}>
    <div
      className={classNames(styles.item, {
        [styles.rec]: type === "rec",
        [styles.illegal]: !legal,
      })}
      onClick={onShow}
    >
      {card.name}
    </div>
    <div className={classNames(styles.buttons, "d-block d-md-none")}>
      {type === "card" && card.legal_commander && (
        <FontAwesomeIcon className="color-gold" icon="crown" size="xl" onClick={onPromote} />
      )}
      <FontAwesomeIcon
        className={styles.link}
        icon="link"
        size="xl"
        onClick={() => window.open(`/${type === "rec" ? "card" : type}s/${card.url}`, "_blank")}
      />
      {type === "rec" ? (
        <FontAwesomeIcon className={styles.addButton} icon="check" onClick={() => onAdd(card)} size="xl" />
      ) : (
        <FontAwesomeIcon className={styles.removeButton} icon="times" onClick={() => onRemove(card.name)} size="xl" />
      )}
    </div>
    <div className={classNames(styles.buttons, "d-none d-md-block")}>
      {type === "card" && card.legal_commander && (
        <FontAwesomeIcon className="color-gold" icon="crown" onClick={onPromote} />
      )}
      <FontAwesomeIcon
        className={styles.link}
        icon="link"
        onClick={() => window.open(`/${type === "rec" ? "card" : type}s/${card.url}`, "_blank")}
      />
      {type === "rec" ? (
        <FontAwesomeIcon className={styles.addButton} icon="check" onClick={() => onAdd(card)} />
      ) : (
        <FontAwesomeIcon className={styles.removeButton} icon="times" onClick={() => onRemove(card.name)} />
      )}
    </div>
  </div>
);

ClipboardItem.propTypes = {
  card: cardBasicType,
  legal: PropTypes.bool.isRequired,
  onAdd: PropTypes.func,
  onPromote: PropTypes.func,
  onRemove: PropTypes.func,
  onShow: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

export default ClipboardItem;
